import { atom, useAtom, useAtomValue, useSetAtom } from "jotai";
import { ProductOptionConfigDataProps } from "@RHCommerceDev/page-pdp/PDPConfiguratorAndCTA/type";

export const productOptionConfigAtom = atom({} as ProductOptionConfigDataProps);

const useSetProductOptionConfigAtomAtom = () =>
  useSetAtom(productOptionConfigAtom);
const useProductOptionConfigAtomValue = () =>
  useAtomValue(productOptionConfigAtom);
const useProductOptionConfigAtom = () => useAtom(productOptionConfigAtom);

export {
  useProductOptionConfigAtom,
  useProductOptionConfigAtomValue,
  useSetProductOptionConfigAtomAtom
};
